import { AuthConfig } from "angular-oauth2-oidc";
import { environment } from "src/environments/environment";

export const teamConfig = {
    responseType: 'code',
    scope: 'openid profile',
    grantType: 'authorization_code',
    issuerUrl: `${environment.team.teamUrl}/authz`,
    discoveryUrl: `${environment.team.teamUrl}/.well-known/openid-configuration`
};

export const authConfig = (code_challenge): AuthConfig => {
    return {
        issuer: teamConfig.issuerUrl,
        redirectUri: window.location.origin,
        clientId: environment.team.clientId,
        logoutUrl: environment.team.logoutUrl,
        responseType: teamConfig.responseType,
        scope: teamConfig.scope,
        skipIssuerCheck: true,
        strictDiscoveryDocumentValidation: false,
        disablePKCE: true,
        customQueryParams: {
            grant_type: teamConfig.grantType,
            code_challenge: code_challenge,
            code_challenge_method: 'S256',
            acr_values: 'OktaGenericADQA',
            audience: environment.audience
        }
    };
};